import { testimonialsData } from '../../../mocks/testimonials';

export default function TestimonialsSection() {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-brown-400"></span>
            <span className="w-2 h-2 rounded-full bg-brown-400"></span>
            <span className="w-2 h-2 rounded-full bg-brown-400"></span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-brown-600 mb-4 leading-tight">
            岡山のお客様から届いた<br className="md:hidden" />喜びの声
          </h2>
          <p className="text-lg md:text-xl text-brown-500 font-serif">
            記念日、結婚、リメイク。大切な想いをカタチに。
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonialsData.map((testimonial) => (
            <article
              key={testimonial.id}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                ))}
              </div>
              
              <h3 className="text-xl md:text-2xl font-serif font-semibold text-brown-600 mb-4">
                {testimonial.title}
              </h3>
              
              <p className="text-base text-brown-500 leading-relaxed mb-6 font-serif">
                {testimonial.content}
              </p>
              
              <div className="flex items-center gap-4">
                <div className="w-16 h-16">
                  <img
                    src={testimonial.avatar}
                    alt={testimonial.name}
                    className="w-full h-full rounded-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-serif text-brown-600">
                    {testimonial.name}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}